import { createContext } from "react";
import { AgenticLogicSurface } from "@src/features/ai/pages/agentic-logic/surface/surface";

export const AgenticLogicSurfaceContext =
  createContext<AgenticLogicSurface | null>(null);
